// extracted by mini-css-extract-plugin
export default {"screenSaver":"screenSaver_screenSaver__61GH9","charging":"screenSaver_charging__ThzY6"};